var React = require('react');

function Coaching (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.5 5H1.5C0.947715 5 0.5 5.39797 0.5 5.88889V20.1111C0.5 20.602 0.947715 21 1.5 21H23.5C24.0523 21 24.5 20.602 24.5 20.1111V5.88889C24.5 5.39797 24.0523 5 23.5 5Z","stroke":"#11AF00","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M17.5 7V1.75C17.5 1.55109 17.3946 1.36032 17.2071 1.21967C17.0196 1.07902 16.7652 1 16.5 1H8.5C8.23478 1 7.98043 1.07902 7.79289 1.21967C7.60536 1.36032 7.5 1.55109 7.5 1.75V7","stroke":"#11AF00","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Coaching.defaultProps = {"width":"25","height":"22","viewBox":"0 0 25 22","fill":"none"};

module.exports = Coaching;

Coaching.default = Coaching;
